module.exports = __webpack_public_path__ + "img/laguara.4d2fde34.png";